import { render, staticRenderFns } from "./ExportacaoParaExcel.vue?vue&type=template&id=331c8322"
import script from "./ExportacaoParaExcel.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportacaoParaExcel.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports